import axios from "axios";

export default {
  namespaced: true,
  state: {
    dialogNewVisit: false,
    loadingAgenda: false,
    idDialog:0,
  },
  mutations: {
    set_idDialog(state) {
      state.idDialog++;
    },
    
    set_loadingAgenda(state, data) {
      state.loadingAgenda = data;
    },
    set_dialogNewVisit(state, payload) {
      state.dialogNewVisit = payload;
    },
    clr_dialogNewVisit(state) {
      state.dialogNewVisit = false;
    },
  },
  actions: {
    visitaAgendaDel: async ({ rootState }, id) => {
      try {
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "ccvisitaJson",
              usuario: rootState.dataUser.Usuario,
              numvisita: id.numvisita,
              cliente: id.cliente,
              opc: 3,
            },
          }
        );
        let status = respuesta.status;
        if (status == 200) {
          let data = await respuesta.data;
       
        }
      } catch (error) {
        console.log(error);
        //commit("ERROR_AXIOS");
      }
    },
    visitaAgenda: async ({ rootState, commit }, id) => {
      try {
        commit("set_loadingAgenda", true);
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "ccvisitaJson",
              usuario: rootState.dataUser.Usuario,
              vendedor: id.vendedor,
              cliente: id.cliente,
              opc: id.opc,
              fecha: id.fecha,
              IndCobros: id.IndCobros,
              IndBoletin: id.IndBoletin,
              IndCall: id.IndCall,
              IndPedidos: id.IndPedidos,
              IndPresupuesto: id.IndPresupuesto,
              notas: id.notas,
              listaped: id.listaped,
              TipoVisita: id.TipoVisita,
              tipoper: id.tipoper,
              Acuerdos: id.Acuerdos,
              cobrado: id.cobrado,
              cheque: id.cheque,
              numvisita: id.numvisita,
            },
          }
        );
        let status = respuesta.status;
        if (status == 200) {
          let data = await respuesta.data;
            commit("set_loadingAgenda", false);
        }

        // commit("set_dsAgenda", dsAgenda);
      } catch (error) {
        console.log(error);
        //commit("ERROR_AXIOS");
      }
    },
  },
  getters: {},
};
